import { apiGet, apiPostForm } from 'api/service';
import { getAccessToken } from 'api/authTokens';

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL || '';

/**
 * Upload BloodHound collector output (one or more .json files, or a .zip) and
 * run the Active Directory audit. Findings are stored in the workspace.
 */
export function runAdAudit(files, userTargetId, engine = 'auto') {
  const form = new FormData();
  const list = Array.isArray(files) ? files : [files];
  list.forEach((f) => form.append('file', f));
  form.append('user_target', userTargetId);
  form.append('engine', engine);
  return apiPostForm('/api/ad-audit/', form);
}

export function listAdAudits(userTargetId) {
  const qs = userTargetId ? `?user_target=${encodeURIComponent(userTargetId)}` : '';
  return apiGet(`/api/ad-audit/list/${qs}`);
}

/**
 * Download the AD report as PDF or CSV.
 *
 * The endpoint returns a file, not JSON, and the API authenticates with a
 * Bearer token rather than a cookie, so this uses an authenticated fetch and a
 * blob download (a plain <a href> would not carry the token).
 *
 * NOTE: the query parameter is `fmt`, not `format` — DRF reserves `format`.
 */
export async function downloadAdReport(scanId, fmt = 'pdf', lang = 'en') {
  const token = getAccessToken();
  const res = await fetch(
    `${API_BASE_URL}/api/ad-audit/report/?scan=${encodeURIComponent(scanId)}&fmt=${fmt}&lang=${lang}`,
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
  if (!res.ok) {
    let detail = `Report failed (${res.status})`;
    try {
      detail = (await res.json()).detail || detail;
    } catch {
      /* non-JSON error */
    }
    throw new Error(detail);
  }
  const disposition = res.headers.get('content-disposition') || '';
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : `ad_audit.${fmt}`;
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return filename;
}
